import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import SideNav from '../../components/SideNav';
import DataTable from '../../components/DataTable';
import EventStatus from '../../components/EventStatus';
import { updateEvent } from '../../redux/slices/eventSlice';
import PageTransition from '../../components/PageTransition';
import Operator from '../../components/Operator';
import ReviewEventInWx from '../../components/ReviewEventInWx';

import request from '@/request';

export default function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const [list, setList] = useState([]);

  useEffect(() => {
    (async () => {
      const res = await request.get('/events/admin/list?page=1&pageSize=999');
      setList(res.items || []);
    })();
  }, []);

  const handleAddEvent = (e) => {
    e.preventDefault();
    if (!user?.org?.cover) {
      message.warning('请先设置主办方封面');
      return;
    }
    dispatch(updateEvent({}));
    navigate('/event');
  };

  const columns = [
    {
      title: '赛事信息',
      key: 'name',
      width: 400,
      render: (_, record) => (
        <div className="flex items-center">
          <img
            src={record.mainPic}
            alt={record.name}
            className="w-32 h-18 object-cover rounded-md mr-4 inline-block"
            style={{ flex: '0 0 auto' }}
          />
          <div className="flex flex-col justify-around items-start">
            <span className="line-clamp-2 break-all mb-1">{record.name}</span>
            <span className="inline-block bg-slate-100 text-slate-700 px-2 py-0.5 rounded-md text-xs font-medium w-44 text-center">
              {record.startDate.substring(0, 10) +
                ' ~ ' +
                record.endDate.substring(0, 10)}
            </span>
          </div>
        </div>
      ),
    },
    {
      title: '报名人次',
      dataIndex: 'applyTotal',
      key: 'applyTotal',
      align: 'center',
    },
    {
      title: '总收益',
      dataIndex: 'incomeTotal',
      key: 'incomeTotal',
      align: 'center',
    },
    {
      title: '总赛项',
      dataIndex: 'itemTotal',
      key: 'itemTotal',
      align: 'center',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (value, record) => (
        <EventStatus text={record?.showStatus} status={value} />
      ),
    },
    {
      title: '操作',
      key: 'action',
      align: 'right',
      render: (_, record) => (
        <div className="flex items-center gap-2 justify-end">
          <Operator
            record={record}
            onEdit={() => {
              dispatch(updateEvent(record));
              navigate(`/event/${record.id}`);
            }}
            removeAPI={record.status < 2 ? '/events' : undefined}
            onRemove={() => {
              request
                .get('/events/admin/list?page=1&pageSize=999')
                .then((res) => {
                  setList(res.items || []);
                });
            }}
          />
          {record.status > 1 && (
            <ReviewEventInWx
              title="报名二维码"
              event={record}
              size={20}
              position="left"
            />
          )}
        </div>
      ),
    },
  ];

  return (
    <PageTransition>
      <SideNav />
      <main className="w-[calc(100vw-17rem)]">
        <div className="flex flex-col items-end bg-white rounded-xl shadow-sm p-6">
          <button
            onClick={handleAddEvent}
            className="h-9 flex items-center justify-center gap-2 px-4 text-sm font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 shadow-sm transition-colors cursor-pointer mb-4"
          >
            <PlusOutlined />
            <span>新增赛事</span>
          </button>
          <div className="w-full">
            <DataTable columns={columns} list={list} />
          </div>
        </div>
      </main>
    </PageTransition>
  );
}
